module.exports = __webpack_public_path__ + "img/big-arrow.f35b9de2.svg";